import React from "react";
import { cn } from "@/lib/utils";
import CircaMark from "./CircaMark";

const CircaWordmark = ({
  className,
  markClassName,
  showTagline = false,
  align = "start",
}) => {
  const centered = align === "center";
  return (
    <div
      className={cn(
        "flex flex-col gap-1",
        centered && "items-center text-center",
        className
      )}
    >
      <div className="flex items-center gap-2.5 text-primary">
        <CircaMark className={cn("h-8 w-8", markClassName)} />
        <span className="text-2xl font-semibold tracking-tight text-foreground">
          Circa
        </span>
      </div>
      {showTagline && (
        <p
          className={cn(
            "text-sm text-muted-foreground",
            centered ? "text-center" : "pl-[2.65rem]"
          )}
        >
          Stay close to what matters
        </p>
      )}
    </div>
  );
};

export default CircaWordmark;
